import AgentRoleListDto from "./AgentRoleListDto";

export default class AgentFormDto {

    constructor(name: string | null, roles: AgentRoleListDto | null) {
        this.Name = name;
        this.Roles = roles;
    }

    Name: string | null;
    Roles: AgentRoleListDto | null;
}